import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { putUpdateDevice } from '../services/putUpdateDevice.service';

export const updateDevice = createAsyncThunk(
  'devices/updateDevice',
  async (device, { getState, rejectWithValue }) => {
    const state = getState();

    const selectedProject = selectSelectedProject(state);
    const businessId = selectedProject?.business_id;

    if (!businessId) {
      return rejectWithValue({ message: 'no business id' });
    }

    const { id, ...deviceData } = device;

    try {
      const updatedDevice = await putUpdateDevice(businessId, id, deviceData);
      return updatedDevice;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
      });
    }
  }
);
